// Side-effect import: injects @font-face for the bundled fonts.
import '~/lib/fonts.web';
import { AppRegistry } from 'react-native';
import { App } from './src/App';

// Inject vector-icon @font-faces so icons render on web (turbo-mobile pattern).
// The font-family MUST match the internal name react-native-vector-icons uses.
/* eslint-disable @typescript-eslint/no-require-imports */
const ICON_FONTS: Record<string, string> = {
  Ionicons: require('react-native-vector-icons/Fonts/Ionicons.ttf'),
};
/* eslint-enable @typescript-eslint/no-require-imports */
const style = document.createElement('style');
style.textContent = Object.entries(ICON_FONTS)
  .map(([family, url]) => `@font-face { font-family: "${family}"; src: url("${url}"); }`)
  .join('\n');
document.head.appendChild(style);

AppRegistry.registerComponent('GlassClassify', () => App);
AppRegistry.runApplication('GlassClassify', {
  rootTag: document.getElementById('root'),
});
